import styled from "@emotion/styled"
import Link from "components/Link"

const ListEighteenLink = styled(Link)`
  text-decoration: none;
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: 18px;
  font-weight: 500;
  line-height: 38px;
  border-bottom: 1px solid transparent;
  transition: all 0.2s;
  margin-bottom: -1px;
  max-width: max-content;
  width: 100%;

  &:hover {
    border-color: ${({ theme }) => theme.palette.primary.main};
  }
`

export default ListEighteenLink
